import { render, staticRenderFns } from "./ProjectView.vue?vue&type=template&id=235c39f3&scoped=true"
import script from "./ProjectView.vue?vue&type=script&lang=ts"
export * from "./ProjectView.vue?vue&type=script&lang=ts"
import style0 from "./ProjectView.vue?vue&type=style&index=0&id=235c39f3&prod&scoped=true&lang=scss"
import style1 from "./ProjectView.vue?vue&type=style&index=1&id=235c39f3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235c39f3",
  null
  
)

export default component.exports